import React from 'react';
const LoginIcon = (props) => {
  return (
    <>    
      {props.text}
    </>
  )
}

export default LoginIcon;